import { ArcadePaymentIconNames } from './ArcadePaymentIcon'
import { PaymentIconNames } from './PaymentIcon'

export type OptionalRecord<K extends keyof any, T> = {
  [P in K]?: T
}

export const BRONTE_TO_ARCADE_PAYMENT_ICONS_MAPPING_GENERATED: OptionalRecord<PaymentIconNames, ArcadePaymentIconNames> = {
  Visa: 'Visa',
  Discover: 'Discover',
  Mastercard: 'Mastercard',
  Jcb: 'Jcb',
  Maestro: 'Maestro',
  Cirrus: 'Cirrus',
  Unionpay: 'Unionpay',
  Dinersclub: 'Dinersclub',
  GenericBank: 'Bank',
  Applepay: 'Applepay',
  Amex: 'Amex',
  CashPay: 'Cashapp',
} as const
